export const mapApiToForm = (list: any[]) => {
  const find = (vertical: number, module: string) =>
    list.find(
      (i) => i.vertical === vertical && i.module === module
    )?.time_lag_days ?? "";

  return {
    glazing_rfq_time_lag: find(1, "RFQ"),
    glazing_sales_team_time_lag: find(1, "SALES"),

    lixil_lixil_time_lag: find(3, "Lixil"),
    lixil_hatchway_time_lag: find(3, "HATCHWAY SALES"),

    hunter_douglas_rfq_time_lag: find(2, "RFQ"),
    hunter_douglas_sales_team_time_lag: find(2, "SALES"),
  };
};
